import walletImage from '../../images/Wallet-payment.png';
import walletImageWhite from '../../images/Wallet-white.png';
import paymentMethods from '../../images/payment-methods.png';

interface props{
    payNowLink: string,
    payLaterLink: string
}
const Footer = ({ payNowLink, payLaterLink }:props) => (
        <>
            <div className="border-top mb-3" />
            <div className="col-11 mb-5 mx-auto">
                <div className="row">
                    <div className="col-xl-8 col-lg-8 col-md-2">
                        <img src={paymentMethods} alt="" />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-10 text-end">
                        <div className="d-flex justify-content-end">
                            <a href={payLaterLink} style={{ textDecoration: 'none' }}>
                                <button id="prevBtn" type="button" className="btn-outline-secondary ms-3">
                                <img src={walletImage} alt="" />
                                <span className="ms-1">Pay Later</span>
                                </button>
                            </a>
                            <a href={payNowLink} style={{ textDecoration: 'none' }}>
                                <button type="button" className="btn btn-success ms-3">
                                    <img src={walletImageWhite} alt="" />
                                    <span className="ms-1">Pay Now</span>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
);
export default Footer;